// src/pages/SuccessPage.js
// import React from "react";
import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/SuccessPage.css";




const SuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { results } = location.state || {};
  const supportRef = useRef(null);
  const successful = Array.isArray(results)
    ? results.filter((r) => r.success !== false)
    : [];
  const failed = Array.isArray(results)
    ? results.filter((r) => r.success === false)
    : [];


    useEffect(() => {
      if (results && results.some((r) => r.success === false) && supportRef.current) {
        // Wait a bit for render, then smooth scroll
        setTimeout(() => {
          supportRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 400);
      }
    }, [results]);

  // ✅ Copy all shipments
  const copyAllShipments = () => {
    if (!Array.isArray(results) || results.length === 0) {
      alert("No shipment data available to copy.");
      return;
    }

    const formattedText = results
      .map((r, i) => {
        return `Dispatch #${i + 1} • ${r.type || "shipment"}
Receiver: ${r.receiver_name || "Recipient"}
State/Zip: ${r.state || "-"}, ${r.zip || "-"}
Carrier: ${r.carrier || "Unknown"}
Carrier Tracking #: ${r.tracking_number || "N/A"}
CJet Tracking ID: ${r.cjetTrackingId || "N/A"}
Status: ${r.success === false ? "❌ Failed" : "✅ Successful"}
${r.error ? "Reason: " + r.error : ""}`;
      })
      .join("\n\n");

    navigator.clipboard.writeText(formattedText);
    alert("✅ All shipment details copied!");
  };

  return (
    <div className="success-container">
      <div className="success-header">
        <h2>
          {failed.length > 0 && successful.length === 0
            ? "❌ All Shipments Failed"
            : failed.length > 0
              ? "⚠️ Some Shipments Failed"
              : "✅ Your Dispatch Has Been Processed!"}
        </h2>
        {Array.isArray(results) && results.length > 0 && (
          <button onClick={copyAllShipments} className="copy-all-btn">
            📋 Copy All Shipments
          </button>
        )}
      </div>

      <p>
        {failed.length > 0 && successful.length === 0
          ? "Unfortunately, all shipments failed. Please review the error messages below."
          : failed.length > 0
            ? "Some shipments couldn’t be processed, but others succeeded. Details below:"
            : "Great news! 🎉 Your documents are being printed and prepared for shipping."}
      </p>

      {/* ✅ Successful Dispatches */}
      {successful.length > 0 && (
        <>
          <h3>✅ Successful Dispatches</h3>
          <ul className="tracking-list">
            {successful.map((r, i) => (
              <li key={i} className="tracking-item">
                <p>
                  <strong>
                    Dispatch #{i + 1} • {r.type || "shipment"}
                  </strong>
                </p>
                <p>
                  👤 <strong>Receiver:</strong> {r.receiver_name || "Recipient"}
                </p>
                <p>
                  🏙️ <strong>State/Zip:</strong> {r.state || "-"}, {r.zip || "-"}
                </p>
                <p>
                  🚚 <strong>Carrier:</strong> {r.carrier || "Unknown"}
                </p>
                {r.tracking_number && (
                  <p>
                    🔗 <strong>Carrier Tracking #:</strong>{" "}
                    <a
                      href={r.tracking_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {r.tracking_number}
                    </a>
                  </p>
                )}
                {r.cjetTrackingId && (
                  <p>
                    🆔 <strong>CJet Tracking ID:</strong>{" "}
                    <a
                      href={`https://cjetdispatch.com/track/${r.cjetTrackingId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {r.cjetTrackingId}
                    </a>
                  </p>
                )}
                <p>
                  📄 Kindly retain your uploaded files until your printed
                  documents are received.
                </p>
              </li>
            ))}
          </ul>

          {/* Support message if any shipment failed */}
          {results.some((r) => r.success === false) && (
            <div
              ref={supportRef}
              className="support-alert"
              style={{
                marginTop: "20px",
                background: "#fff5f5",
                border: "1px solid #f5c2c7",
                borderRadius: "8px",
                padding: "12px 16px",
              }}
            >
              <p style={{ color: "#b91c1c", fontWeight: 600 }}>
                ⚠️ One or more shipments failed to process.
              </p>
              <p style={{ color: "#7f1d1d", fontSize: "14px", marginTop: "4px" }}>
                Please verify the address and try again. If you believe this was an error, contact our support team at{" "}
                <a
                  href="mailto:support@cjetdispatch.com"
                  style={{ color: "#b91c1c", fontWeight: "bold", textDecoration: "none" }}
                >
                  support@cjetdispatch.com
                </a>.
              </p>
            </div>
          )}
        </>
      )}

      {/* ❌ Failed Dispatches */}
      {failed.length > 0 && (
        <>
          <h3>❌ Failed Dispatches</h3>
          <ul className="tracking-list">
            {failed.map((r, i) => (
              <li key={`fail-${i}`} className="tracking-item">
                <p>
                  <strong>
                    Dispatch #{i + 1} • {r.type || "shipment"}
                  </strong>
                </p>
                <p>
                  👤 <strong>Receiver:</strong> {r.receiver_name || "Recipient"}
                </p>
                <p>
                  🏙️ <strong>State/Zip:</strong> {r.state || "-"}, {r.zip || "-"}
                </p>
                <p>
                  🚫 <strong>Status:</strong> Failed to Process
                </p>
                {r.error && (
                  <p>
                    ⚠️ <strong>Reason:</strong>{" "}
                    <span style={{ color: "red" }}>{r.error}</span>
                  </p>
                )}
              </li>
            ))}
          </ul>
        </>
      )}

      <div className="next-steps">
        <p>
          To follow your shipment journey, tap the{" "}
          <strong>tracking number</strong> shown above.
        </p>
      </div>

      <button className="return-button" onClick={() => navigate("/dashboard")}>
        🚀 Send Another Dispatch
      </button>
    </div>
  );
};

export default SuccessPage;




